import React from 'react';
import PropTypes from 'prop-types';
import ResetPasswordStage1 from './ResetPasswordStage1';
import ResetPasswordStage2 from './ResetPasswordStage2';

import './reset-password.scss';

const PasswordReset = (props) => {
  console.log('PasswordReset++', props);
  return (
    <React.Fragment>
      {
        props.resetToken ? (
          <ResetPasswordStage2 resetToken={props.resetToken} closeModal={props.closeModal} />
        ) : (
          <ResetPasswordStage1 closeModal={props.closeModal} />
        )
      }
    </React.Fragment>
    
  );
}

PasswordReset.propTypes = {
  resetToken: PropTypes.string,
  closeModal: PropTypes.func.isRequired,
}

export default PasswordReset;



// WEBPACK FOOTER //
// ./src/components/Modal/ResetPassword/index.js